import type {ThemeIconKey} from 'platform/foundation';

import type {TabId} from './tabLabels';

export const sectionIcons = {
  'trim-levels': 'action/view_agenda',
  engines: 'specification/power',
  'variant-matrix': 'editor/table_chart',
  colours: 'action/invert_colors',
  upholstery: 'action/event_seat',
  features: 'action/toc',
} as const satisfies Partial<Record<TabId, ThemeIconKey>>;
